<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption col-md-12">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">Topic Quiz : {{topicTitle}}</h3>
              </div>
            </div>
            <div class="m-portlet__head-back_button col-md-6 text-right">
              <button class="btn btn-info mt-4 back-page" @click="goBacktoTopic()">Back to Topic</button>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <div v-if="quizCount > 0" class="m-portlet m-portlet--mobile" id="quiz">
                  <!-- Portlet Body Start -->
                  <div class="m-portlet__body">
                    <div class="alert alert-success" id="success-alert" style="display:none;">
                      <button type="button" class="close" data-dismiss="alert">x</button>
                      <strong>Success! </strong> You have successfully completed the quiz.
                    </div>
                    <div class="alert alert-danger notify-bar" id="fail-alert" v-if="failMessage">
                      <ul>
                        <li v-for="(error,index) in fail_error" :key="index">
                          {{ error }}
                        </li>
                      </ul>
                    </div>
                    <div :class="'quiz_item_' + index" v-for="(item,index) in questions" :key="index" :style="{display: (currentQuestion === (index + 1))? 'block': 'none'}">
                      <div style=" float:right; padding:10px;" id="qNumber" class="question">{{index + 1}} / {{quizCount}}</div>
                      <div class="alert alert-danger" role="alert" id="answer-error" style="display:none"></div>
                      <div class="alert alert-warning quiz_empty_msg" style="display: none;">Questions are not found on Selected Topic!</div>
                      <form action="" class="m-form">
                        <div class="form-group">
                          <label for="" class="form-control-label m--margin-bottom-15">
                            <div id="questionText">{{item.question}}</div>
                          </label>
                          <div class="m-radio-list" id="answers">
                            <ul class="answer_list">
                              <li class="answer_list_item" v-if="item.option_1 !== null"><input type="radio" :name="'answers_' + index" value="1">{{item.option_1}}</li>
                              <li class="answer_list_item" v-if="item.option_2 !== null"><input type="radio" :name="'answers_' + index" value="2">{{item.option_2}}</li>
                              <li class="answer_list_item" v-if="item.option_3 !== null"><input type="radio" :name="'answers_' + index" value="3">{{item.option_3}}</li>
                              <li class="answer_list_item" v-if="item.option_4 !== null"><input type="radio" :name="'answers_' + index" value="4">{{item.option_4}}</li>
                              <li class="answer_list_item" v-if="item.option_5 !== null"><input type="radio" :name="'answers_' + index" value="5">{{item.option_5}}</li>
                              <li class="answer_list_item" v-if="item.option_6 !== null"><input type="radio" :name="'answers_' + index" value="6">{{item.option_6}}</li>
                              <li class="answer_list_item" v-if="item.option_7 !== null"><input type="radio" :name="'answers_' + index" value="7">{{item.option_7}}</li>
                              <li class="answer_list_item" v-if="item.option_8 !== null"><input type="radio" :name="'answers_' + index" value="8">{{item.option_8}}</li>
                              <li class="answer_list_item" v-if="item.option_9 !== null"><input type="radio" :name="'answers_' + index" value="9">{{item.option_9}}</li>
                              <li class="answer_list_item" v-if="item.option_10 !== null"><input type="radio" :name="'answers_' + index" value="10">{{item.option_10}}</li>
                            </ul>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- Portlet Body End -->
                  <div class="m-portlet__foot" style ="height:70px;">
                    <button class="btn btn-info btn-danger" id="prev" v-if="isPrevShow" @click="prevQuestion()">Prev</button>
                    <button class="btn btn-info btn-danger float-right" v-if="isNextShow" id="nextsave"  @click="nextQuestion()">Next</button>
                    <button class="btn btn-info btn-danger float-right" id="finish" v-if="isFinishShow" @click="finish()">Finish</button>
                  </div>

                </div>
                <div v-else class="col-md-12">
                  <div class="empty-data">
                    <img src="/media/icons/empty.png" />
                    <h2>Quiz not available</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>

  </div>

</template>

<script>
var $ = require('jquery')
var Cookies = require('vue-cookies')
var Config = require('../router/Config')

module.exports = {
  name: 'topic_quiz',
  components: {},
  data () {
    return {
      api_url: Config.API_URL,
      topicTitle: '',
      questions: [],
      quizCount: 0,
      currentQuestion: 1,
      isNextShow: true,
      isPrevShow: false,
      isFinishShow: false,
      failMessage: false,
      fail_error: []
    }
  },
  mounted () {
    this.getTopicQuiz()
  },
  methods: {
    getTopicQuiz: function () {
      this.axios.get(this.api_url + '/api/fe/topic/questions/' + Cookies.get('topicId') + '?token=' + Cookies.get('accessToken')).then(response => {
        console.log('getTopicQuiz')
        console.log(response.data.data)
        if (response.data.res === 1) {
          var quizData = response.data.data
          this.questions = quizData.questions
          this.quizCount = this.questions.length
          this.topicTitle = quizData.name
          if (this.currentQuestion === this.quizCount) {
            this.isFinishShow = true
            this.isNextShow = false
          }
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    goBacktoTopic: function () {
      Cookies.get('topicId')
      this.$router.replace({ name: 'topics' })
    },
    nextQuestion: function () {
      this.currentQuestion++
      if (this.currentQuestion !== 1) {
        this.isPrevShow = true
      }
      if (this.currentQuestion === this.quizCount) {
        this.isFinishShow = true
        this.isNextShow = false
      }
    },
    prevQuestion: function () {
      this.currentQuestion--
      if (this.currentQuestion === 1) {
        this.isPrevShow = false
      }
      if (this.currentQuestion !== this.quizCount) {
        this.isFinishShow = false
        this.isNextShow = true
      }
    },
    finish: function () {
      $('#finish').prop('disabled', true)
      var quizDataArray = []
      for (let index = 0; index < this.quizCount; index++) {
        var selectedAnswer = $("input[name='answers_" + index + "']:checked").val()
        var noOfCorrection = 0
        if (selectedAnswer !== undefined) {
          if (this.questions[index].answer === selectedAnswer) {
            noOfCorrection = 1
          } else {
            noOfCorrection = 0
          }
          quizDataArray[index] = {
            no_of_correction: noOfCorrection,
            question_id: this.questions[index].id,
            select_ans: selectedAnswer
          }
        } else {
          noOfCorrection = 2
          this.fail_error[index] = 'Please answer question no: ' + (index + 1)
        }
      }
      var self = this
      if (this.fail_error.length === 0) {
        this.axios.post(this.api_url + '/api/fe/topic/finish' + '?token=' + Cookies.get('accessToken'), {
          user_id: Cookies.get('userId'),
          course_id: Cookies.get('courseId'),
          subject_id: Cookies.get('subjectId'),
          chapter_id: Cookies.get('chapterId'),
          topic_id: Cookies.get('topicId'),
          quiz_data: quizDataArray
        }).then(response => {
          $('#finish').prop('disabled', false)
          if (response.data.res === 1) {
            $('#success-alert').fadeTo(5000, 500).slideUp(500, function () {
              self.$router.replace({ name: 'topics' })
            })
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        $('#finish').prop('disabled', false)
        this.failMessage = true
        setTimeout(function () {
          self.failMessage = false
          self.fail_error = []
        }, 2000)
      }
    }
  }
}

</script>

<style scoped lang="scss">
  @import "../assets/scss/component/quiz/quiz";
</style>
